import Script from "next/script";

const Pylon = () => {
  if (
    !["staging", "production"].includes(process.env.NEXT_PUBLIC_ENV as string)
  )
    return null;

  return (
    <Script id="pylon-script">{`(function(){var e=window;var t=document;var n=function(){n.e(arguments)};n.q=[];n.e=function(e){n.q.push(e)};e.Pylon=n;var r=function(){var e=t.createElement("script");e.setAttribute("type","text/javascript");e.setAttribute("async","true");e.setAttribute("src","https://widget.usepylon.com/widget/${process.env.NEXT_PUBLIC_PYLON_APP_ID}");var n=t.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};if(t.readyState==="complete"){r()}else if(e.addEventListener){e.addEventListener("load",r,false)}})();`}</Script>
  );
};

export default Pylon;
